<script>
/**
 * @description Компонент таймера.
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Заголовок.
     */
    title() {
      const remainingSeconds = this.remainingMs / 1000;
      return [remainingSeconds / 60, remainingSeconds % 60]
        .map((value) => String(Math.floor(value)).padStart(2, '0'))
        .join(':');
    },
  },
  data() {
    const calcRemainingMs = (actualMs) => (actualMs < this.finishMs ? this.finishMs - actualMs : 0);
    return {
      /**
       * @description Расчет оставшихся миллисекунд.
       * @type {function}
       */
      calcRemainingMs,
      /**
       * @description Оставшееся количество миллисекунд.
       * @type {number}
       */
      remainingMs: calcRemainingMs(this.actualMs),
    };
  },
  methods: {
    /**
     * @description Обработать продвижение времени.
     * @returns {void}
     */
    onTick() {
      const nextRemainingMs = this.calcRemainingMs(this.actualMs, this.finishMs);
      if (this.remainingMs === nextRemainingMs) {
        this.$emit('timeout');
      }
      this.remainingMs = nextRemainingMs;
    },
  },
  props: {
    /**
     * @description Текущие миллисекунды.
     */
    actualMs: {
      required: true,
      type: Number,
    },
    /**
     * @description Конечные миллисекунды.
     */
    finishMs: {
      required: true,
      type: Number,
    },
  },
  render(createElement) {
    return createElement('span', this.title);
  },
  watch: {
    actualMs() {
      this.onTick();
    },
  },
};
</script>
